// 複刻文化 Fuko — 網站設定與外部連結
// 僅包含已確認的品牌資訊
// 正式內容請以崧博出版官方資料為準

export const siteSettings = {
  brandName: '複刻文化',
  brandNameEn: 'Fuko',
  companyName: '複刻文化事業有限公司',
  description:
    '複刻文化以歷史、人文社科、公版經典與小說為主要出版方向，透過整理、編輯與出版，讓不同時代的作品以適合當代讀者的形式重新進入閱讀視野。',
  seoTitle: '複刻文化 Fuko｜歷史、人文社科、公版經典與小說',
  officialUrl: 'https://fuko.sonbook.net',
  email: 'contact@fuko.sonbook.net',
  copyright: '© 2026 複刻文化事業有限公司',
};

export const externalLinks = {
  songbo: 'https://sonbook.net/',
  catalog: 'https://catalog.sonbook.net',
};